import React from 'react';
import { useEditorStore } from '../../stores/editorStore';
import { useSettingsStore } from '../../stores/settingsStore';

const formatDate = (dateStr: string): string => {
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr; // Return as-is if invalid
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const BottomBar: React.FC = () => {
  const { settings } = useSettingsStore();
  const { currentEpisode } = useEditorStore();

  return (
    <div className="h-36 bg-black/80 rounded-xl flex items-center justify-end px-0 flex-shrink-0">
      <div className="flex items-center gap-8">
        <span className="font-medium text-6xl" style={{ color: settings.accentColor }}>
          {currentEpisode?.showTitle || settings.showName}
        </span>
        {currentEpisode?.date && (
          <>
            <span className="text-gray-600 text-4xl">|</span>
            <span className="text-gray-400 text-6xl">
              {formatDate(currentEpisode.date)}
            </span>
          </>
        )}
      </div>
    </div>
  );
};
